module.exports = __webpack_public_path__ + "static/media/onboard-step-5.ac149fc3.png";